<template>
  <form @submit="submit($event)">
    <select-input :required="true" label="Выберите профиль" name="PROFILE" :options="options"
                  v-model="currentProfile"></select-input>
    <text-input :required="true" label="Введите email на который отправить акт сверки" name="EMAIL" type="email"
                v-model="email"></text-input>
    <date-input :required="true" name="DATE_START" v-model="dateStart" label="Дата начала"></date-input>
    <date-input :required="true" name="DATE_END" v-model="dateEnd" label="Дата окончания"></date-input>
    <btn title="Запросить"></btn>
  </form>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SelectInput from './form/SelectInput'
  import TextInput from './form/TextInput'
  import Btn from './form/Btn'
  import DateInput from './form/DateInput'

  export default {
    name: 'request-reconciliation',
    components: {DateInput, Btn, TextInput, SelectInput},
    created () {
      if (this.personTypes.length <= 0) {
        this.$store.dispatch('profile/fetchProfiles')
      }
    },
    computed: {
      ...mapGetters('profile', [
        'legalProfiles',
        'personTypes'
      ]),
      currentProfile: {
        get () {
          return this.$store.state.reconciliation.currentProfile
        },
        set (currentProfile) {
          this.$store.commit('reconciliation/setCurrentProfile', {currentProfile})
        }
      },
      email: {
        get () {
          return this.$store.state.reconciliation.email
        },
        set (email) {
          this.$store.commit('reconciliation/setEmail', {email})
        }
      },
      dateStart: {
        get () {
          return this.$store.state.reconciliation.dateStart
        },
        set (dateStart) {
          this.$store.commit('reconciliation/setDateStart', {dateStart})
        }
      },
      dateEnd: {
        get () {
          return this.$store.state.reconciliation.dateEnd
        },
        set (dateEnd) {
          this.$store.commit('reconciliation/setDateEnd', {dateEnd})
        }
      },

      options () {
        let options = []

        for (let profile of this.legalProfiles) {
          options.push({
            title: profile.name,
            value: profile.id
          })
        }

        return options
      }
    },
    methods: {
      async submit ($event) {
        $event.preventDefault()
        await this.$store.dispatch('reconciliation/send')
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequestReconciliation.vue